var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fadeSlider"},_vm._l((_vm.items),function(item,i){return _c('div',{key:item.id,staticClass:"fadeSlider__item",class:[_vm.options.itemClass, { 'is-active-slide': _vm.now === i }]},[_c('img',{attrs:{"src":item.image.url,"alt":"item.image.alt"}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ccc0c0e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/fadeSlider/component.vue
// module id = null
// module chunks = 